
export const diagnosisQueryDft = {
    type: 'exception',
};
